import React, { createContext, useState, ReactNode } from 'react';
import {
  OptionInterface,
  ResidenceInterface,
  StateProvince,
} from '../../interface/CustomerInformationInterface';

interface ResidenceContextInterface {
  residenceInformation: ResidenceInterface;
  setResidenceInformation: React.Dispatch<
    React.SetStateAction<ResidenceInterface>
  >;
  residenceDoc: string;
  setResidenceDoc: React.Dispatch<React.SetStateAction<string>>;
  fileSize: string;
  setFileSize: React.Dispatch<React.SetStateAction<string>>;
  fileType: string;
  setFileType: React.Dispatch<React.SetStateAction<string>>;
  showResidenceVerfDocument: boolean;
  setShowResidenceVerfDocument: React.Dispatch<React.SetStateAction<boolean>>;
  residenceRadioOption: OptionInterface[];
  setResidenceRadioOption: React.Dispatch<
    React.SetStateAction<OptionInterface[]>
  >;
  residenceTenureTypeOption: OptionInterface[];
  setResidenceTenureTypeOption: React.Dispatch<
    React.SetStateAction<OptionInterface[]>
  >;
  stateOption: OptionInterface[];
  setStateOption: React.Dispatch<React.SetStateAction<OptionInterface[]>>;
  stgCustomerAddressId: string;
  setStgCustomerAddressId: React.Dispatch<React.SetStateAction<string>>;
  stateDetails: StateProvince[];
  setStateDetails: React.Dispatch<React.SetStateAction<StateProvince[]>>;
  residenceSave: boolean;
  setResidenceSave: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResidenceContext = createContext<ResidenceContextInterface | undefined>(
  undefined
);

const ResidenceContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [residenceInformation, setResidenceInformation] =
    useState<ResidenceInterface>({
      street: '',
      exteriorNumber: '',
      interiorNumber: '',
      suburb: '',
      postalCode: '',
      city: '',
      state: '',
      timeOccupyingCurrentResidence: '',
      typeOfResidence: '',
    });
  const [residenceDoc, setResidenceDoc] = useState<string>('');
  const [fileSize, setFileSize] = useState<string>('');
  const [fileType, setFileType] = useState<string>('');
  const [showResidenceVerfDocument, setShowResidenceVerfDocument] =
    useState<boolean>(false);
  const [residenceRadioOption, setResidenceRadioOption] = useState<
    OptionInterface[]
  >([]);
  const [residenceTenureTypeOption, setResidenceTenureTypeOption] = useState<
    OptionInterface[]
  >([]);
  const [stateOption, setStateOption] = useState<OptionInterface[]>([]);
  const [stateDetails, setStateDetails] = useState<StateProvince[]>([]);
  const [stgCustomerAddressId, setStgCustomerAddressId] = useState<string>('');
  const [residenceSave, setResidenceSave] = useState<boolean>(false);

  return (
    <ResidenceContext.Provider
      value={{
        residenceInformation,
        setResidenceInformation,
        residenceDoc,
        setResidenceDoc,
        fileSize,
        setFileSize,
        fileType,
        setFileType,
        showResidenceVerfDocument,
        setShowResidenceVerfDocument,
        residenceRadioOption,
        setResidenceRadioOption,
        residenceTenureTypeOption,
        setResidenceTenureTypeOption,
        stateOption,
        setStateOption,
        stgCustomerAddressId,
        setStgCustomerAddressId,
        stateDetails,
        setStateDetails,
        residenceSave,
        setResidenceSave,
      }}
    >
      {props.children}
    </ResidenceContext.Provider>
  );
};

export { ResidenceContext, ResidenceContextProvider };
